import { put, select } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import axios from 'src/api/Api';
import {
    GET_BATCH_ALLOCATIONS_SUCCESS,
    GET_BATCH_ALLOCATIONS_FAILURE,
} from '../actions';
import {
    convertObjectToQueryParams,
    convertDateToISOString,
} from 'src/utils/util';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import { COUNTRY_CODE_JAPN } from 'src/constants/productConstants';
import { US_COUNTRY_CODE } from 'src/constants/appConstants';

export default function* getShippingBatchAllocations(action) {
    const { accountId, territoryId, surgeryDateTime } = yield select(
        (state) => ({
            accountId: state.surgeryReducer.surgeryDetails.accountId.accountId,
            territoryId: state.surgeryReducer.surgeryDetails.territoryId,
            surgeryDateTime: convertDateToISOString(
                new Date(state.surgeryReducer.surgeryDetails.surgeryDateTime),
                'end'
            ),
        })
    );
    const { isMastOrder } = yield select((state) => ({
        isMastOrder: state.loginReducer.isMastOrder
    }));
    const countryISOCode = yield select((state) => state.loginReducer.hybrisUserDetails.countryISOCode);
    const cfnsRaw = action?.payload?.cfn;
    const allCfns = Array.isArray(cfnsRaw)
        ? cfnsRaw
        : cfnsRaw
        ? [cfnsRaw]
        : [];

    // Filter out CFNs already fetched or currently in-flight to avoid duplicate API calls
    const { alreadyFetched, pendingCfns } = yield select(
        (state) => ({
            alreadyFetched: state.shippingBatchAllocation.batchAllocations,
            pendingCfns: state.shippingBatchAllocation.pendingCfns || [],
        })
    );
    const alreadyFetchedCfns = new Set(
        alreadyFetched.map((b) => b.productCfn)
    );
    // pendingCfns includes the current action's CFNs (added by the reducer before the saga runs),
    // so a CFN is considered in-flight if it appears more than once in pendingCfns.
    const inFlightCfns = new Set();
    const seen = {};
    for (const cfn of pendingCfns) {
        seen[cfn] = (seen[cfn] || 0) + 1;
        if (seen[cfn] > 1) {
            inFlightCfns.add(cfn);
        }
    }
    const productCfns = allCfns.filter(
        (cfn) => !alreadyFetchedCfns.has(cfn) && !inFlightCfns.has(cfn)
    );

    if (productCfns.length === 0) {
        return;
    }

    const url = `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/products/batchallocations?${convertObjectToQueryParams(
        {
            productCfns,
            isReservationSet: action.payload.isReservationSet || false,
            accountId,
            territoryId,
            surgeryDateTime,
            isMastOrder: isMastOrder,
        },
        true
    )}`;
    try {
        const result = yield axios.get(url).then((response) => response.data);
        const ArrayToRemoveSelection =  {
            'currentLocation': '',
            'id': '',
            'isBatchAlreadyAllocated': false,
            'isRemoveSelection':true,
            'isParked': false
        };
        const setAllocationsArray = result.setAllocations || [];

        const setAllocationsArray_With_ArrayToRemoveSelection = setAllocationsArray?.map((a) => ({
            ...a,
            batchAllocations: a.batchAllocations?.filter((t) => countryISOCode !== US_COUNTRY_CODE || t.isParked)?.length > 0 && !action.payload.isReservationSet
                ? [...(a.batchAllocations?.filter((t) => countryISOCode !== US_COUNTRY_CODE || t.isParked)), ArrayToRemoveSelection]
                : a.batchAllocations?.filter((t) => countryISOCode !== US_COUNTRY_CODE || t.isParked) || [],
        }));
        yield put({
            type: GET_BATCH_ALLOCATIONS_SUCCESS,
            payload: setAllocationsArray_With_ArrayToRemoveSelection,
            statusCode: result.statusCode,
            statusMessage: result.statusMessage,
        });
    } catch (e) {
        yield logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action?.payload || '',
        });
        yield put({
            type: GET_BATCH_ALLOCATIONS_FAILURE,
            statusCode: errorHandler('503'),
            statusMessage: e.Error,
        });
    }
}
